// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__tRE6e","menu_item":"Sidebar_menu_item__VIfKw"};